import { OptionListSchema } from "../models/OptionListSchema";

export const QUOTE_OPTION_DATA: OptionListSchema[] = [
  {
    id: 1,
    name: "Raise Enquiry",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240212091539-file-box-grey.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240129112554-file-box.svg",
    tabOptionName: "raiseEnquiry",
    redirectionUrl: "/quote/raise",
  },
  {
    id: 2,
    name: "Status",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240212093042-activity.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240129144253-activity+%281%29.svg",
    tabOptionName: "status",
    redirectionUrl: "/quotes",
  },
];

export const PURCHASE_ORDER_OPTION_DATA: OptionListSchema[] = [
  {
    id: 1,
    name: "Order",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240212093013-book-open-check.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240129144440-book-open-check+%281%29.svg",
    tabOptionName: "order",
    redirectionUrl: "/purchase-order/orders",
  },
  {
    id: 2,
    name: "Track",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240212093042-activity.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240129144253-activity+%281%29.svg",
    tabOptionName: "status",
    redirectionUrl: "/purchase-orders",
  },
];

export const VENDOR_OPTION_DATA: OptionListSchema[] = [
  {
    id: 2,
    name: "Manage",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240212093042-activity.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240129144253-activity+%281%29.svg",
    tabOptionName: "manage",
    redirectionUrl: "/vendors",
  },
];
export interface SIDEBAR_OPTION {
  name: string;
  iconUrl: string;
  activeIconUrl: string;
  tabName: string;
  redirectionUrl: string;
  options: OptionListSchema[];
  invalidRoles: string[];
}
export const SIDEBAR_DATA: SIDEBAR_OPTION[] = [
  {
    name: "SKU",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240417144546-list-outline.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240417144546-list-outline.svg",
    tabName: "sku",
    redirectionUrl: "/skus",
    options: [],
    invalidRoles: [],
  },
  {
    name: "Forms",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250310110815-lets-icons_form-light.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250310110815-lets-icons_form-light.svg",
    tabName: "vendorForms",
    redirectionUrl: "/forms",
    options: [],
    invalidRoles: [""],
  },
  {
    name: "Vendors",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240826080435-hammer-outline.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240826080435-hammer-outline.svg",
    tabName: "vendors",
    redirectionUrl: "/vendors",
    options: [],
    invalidRoles: [""],
  },
  {
    name: "Auction",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20241023145142-Group+1171276134.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20241023145142-Group+1171276134.svg",
    tabName: "auction",
    redirectionUrl: "/auctions",
    options: [],
    invalidRoles: ["SUNLIGHT", "RAYZON", ""],
  },
  {
    name: "Quote",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240131090019-cube-outline.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240212092652-cube-white.svg",
    tabName: "quotes",
    options: QUOTE_OPTION_DATA,
    redirectionUrl: "-",
    invalidRoles: ["SUNLIGHT", "RAYZON", ""],
  },
  {
    name: "Purchase Order",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240131090225-cart-outline.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240212092652-cart-white.svg",
    tabName: "purchaseOrder",
    redirectionUrl: "-",
    options: PURCHASE_ORDER_OPTION_DATA,
    invalidRoles: [],
  },
  {
    name: "Delivery Calendar",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240516052108-calendar.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240516052108-calendar.svg",
    tabName: "deliveryCalendar",
    redirectionUrl: "/delivery-calendar",
    options: [],
    invalidRoles: [],
  },
  {
    name: "Quality Check",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240730112901-traffic-cone.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240730112901-traffic-cone.svg",
    tabName: "qualityCheck",
    redirectionUrl: "/quality-checks",
    options: [],
    invalidRoles: [],
  },
  {
    name: "Negotiations",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20241225233050-indian-rupee.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20241225233050-indian-rupee.svg",
    tabName: "negotiations",
    redirectionUrl: "/negotiations",
    options: [],
    invalidRoles: [],
  },
  {
    name: "Workflows",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250303115158-workflow.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250303115158-workflow.svg",
    tabName: "workflows",
    redirectionUrl: "/workflows",
    options: [],
    invalidRoles: ["SUNLIGHT", "RAYZON", "HAPPI_PLANET"],
  },
  {
    name: "Notifications",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250325090905-bell.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250325090905-bell.svg",
    tabName: "notifications",
    redirectionUrl: "/notifications",
    options: [],
    invalidRoles: [""],
  },
  {
    name: "Request",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250318112034-hugeicons_task-edit-01.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250318112034-hugeicons_task-edit-01.svg",
    tabName: "request",
    redirectionUrl: "/requests",
    options: [],
    invalidRoles: ["HAPPI_PLANET"],
  },
  {
    name: "Reports",
    iconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250318112034-hugeicons_task-edit-01.svg",
    activeIconUrl:
      "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250318112034-hugeicons_task-edit-01.svg",
    tabName: "report",
    redirectionUrl: "/reports",
    options: [],
    invalidRoles: [],
  },
];

export const getSidebarOptions = (roles: string[]) => {
  const options: SIDEBAR_OPTION[] = [];
  SIDEBAR_DATA.forEach((opt) => {
    let found = false;
    opt.invalidRoles?.forEach((role) => {
      found = found || roles.indexOf(role) > -1;
    });
    if (!found) {
      options.push(opt);
    }
  });
  return options;
};
